import { Invoice, InvoiceState, InvoiceSubkind } from "@oysterhr/schema"
import type { TFunction } from "react-i18next"

export const getClientInvoiceDueDate = (
  { state, subkind, dueDate }: Pick<Invoice, "state" | "subkind" | "dueDate">,
  t?: TFunction,
): string | null | undefined => {
  if (
    subkind === InvoiceSubkind.OysterDeposit &&
    state === InvoiceState.WaitingApproval &&
    !dueDate
  )
    return t?.("table.dueDateServiceAgreement")

  return dueDate || null
}
